export default __webpack_public_path__ + "static/media/icon_mail_open.638926a4.svg";